import * as Sentry from '@sentry/react';

/**
 * Patterns that are not our defects and must never be billed as an event.
 * See the note in apps/web/src/sentry.client.config.ts — Office/Outlook link
 * scanning emits `Object Not Found Matching Id` with no stack trace.
 */
const IGNORED_ERRORS: (string | RegExp)[] = [
  /Object Not Found Matching Id/i,
  /Non-Error promise rejection captured with value: Object Not Found/i,
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i,
  /^Script error\.?$/i,
];

const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracePropagationTargets: [/^https:\/\/.*\.hts\.pro$/, /^https:\/\/harris-technology-services\.com$/, /^https:\/\/.*\.azurewebsites\.net$/],
    // Production tracing is OFF on purpose — 13.3M spans vs ~6k errors measured
    // org-wide over 30 days on 2026-08-25. Re-enabling is a cost decision.
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0 : 1.0,
    enableLogs: true,
    ignoreErrors: IGNORED_ERRORS,
    // Replay only when something actually failed: 24 of 25 sampled replays over
    // 30 days contained ZERO errors at the previous 0.1 session rate.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.replayIntegration()],
  });
}
